module.exports = __webpack_public_path__ + "static/img/bgimg3-4.d24dc69c.png";